import { Box, Stack, styled, Typography } from '@mui/material'
import { t } from '$i18n'

const StyledBox = styled(Box)`
  margin-right: 8px;
`

export function Separator() {
  return (
    <Stack direction="row" sx={{ margin: '0 15px', alignItems: 'center' }}>
      <Typography variant="caption1" color="gray">
        {t('bookmarkModal.management')}
      </Typography>
      <StyledBox
        sx={{
          height: '1px',
          width: '100%',
          backgroundColor: 'veryVeryLightGray',
        }}
      />
    </Stack>
  )
}
